import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/index.vue";

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function (location) {
  return routerReplace.call(this, location).catch((error) => error);
};

Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      meta: { title: "登陆", hiddenLayout: true },
      component: () => import("@/views/login/index"),
    },
    {
      path: "/register",
      name: "register",
      meta: { title: "注册", hiddenLayout: true },
      component: () => import("@/views/register/index"),
    },
    {
      path: "/",
      name: "home",
      meta: { title: "首页", hiddenLayout: true },
      component: Home,
    },
    {
      path: "/bgfw",
      name: "bgfw",
      meta: { title: "报关服务" },
      component: () => import("@/views/bgfw/index"),
    },
    {
      path: "/jrfw",
      name: "jrfw",
      meta: { title: "金融服务" },
      component: () => import("@/views/jrfw/index"),
    },
    {
      path: "/kjds",
      name: "kjds",
      meta: { title: "跨境电商" },
      component: () => import("@/views/kjds/index"),
    },
    {
      path: "/wmzh",
      name: "wmzh",
      meta: { title: "外贸综合" },
      component: () => import("@/views/wmzh/index"),
    },
    {
      path: "/wmgj",
      name: "wmgj",
      meta: { title: "外贸工具" },
      component: () => import("@/views/wmgj/index"),
    },
    {
      path: "/stfw",
      name: "stfw",
      meta: { title: "生态服务" },
      component: () => import("@/views/stfw/index"),
    },
    {
      path: "/zxzx",
      name: "zxzx",
      meta: { title: "咨询中心" },
      component: () => import("@/views/zxzx/index"),
    },
    {
      path: "/cxjg",
      name: "cxjg",
      meta: { title: "查询结果" },
      component: () => import("@/views/zxzx/cxjg.vue"),
    },
    {
      path: "/zxdetails",
      name: "zxdetails",
      meta: { title: "咨询内容" },
      component: () => import("@/views/zxzx/zxdetails.vue"),
    },
    {
      path: "/gywm",
      name: "gywm",
      meta: { title: "关于我们" },
      component: () => import("@/views/gywm/index"),
    },
    {
      path: "/lxwm",
      name: "lxwm",
      meta: { title: "联系我们" },
      component: () => import("@/views/lxwm/index"),
    },
  ],
});

// 监听路由变化
router.beforeEach((to, from, next) => {
  // 当路由变化时，将页面滚动到顶部
  window.scrollTo(0, 0);
  next();
});

export default router;
